import { render, staticRenderFns } from "./FirstFlg.vue?vue&type=template&id=a2e745b0&"
import script from "./FirstFlg.vue?vue&type=script&lang=ts&"
export * from "./FirstFlg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports